import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance3chrc9ba7w7cn as Companion_getInstance,
  SerializableAnnotation2h7cqfq6xt1yy as SerializableAnnotation,
  Companion_getInstance335jj07k1liay as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import { to2cs3ny02qtbcb as to } from '../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Companion_getInstance3eoge8j03l9b5 as Companion_getInstance_1 } from '../../../lightning-server-shared/com/lightningkite/serialization/SerializationRegistry.mjs';
import { prepareCrowPayLegalDocumentFields3bapu57ipmpnj as prepareCrowPayLegalDocumentFields } from './CrowPayLegalDocumentFields.mjs';
import { prepareLegalDocumentAgreementFields36049zp6jp0m0 as prepareLegalDocumentAgreementFields } from './LegalDocumentAgreementFields.mjs';
import { prepareChangeRequestFields37ox4nkpqy655 as prepareChangeRequestFields } from './ChangeRequestFields.mjs';
import { prepareClientFieldsyptl4y6dulio as prepareClientFields } from './ClientFields.mjs';
import { prepareOwnerFieldsjlfj72vly6cj as prepareOwnerFields } from './OwnerFields.mjs';
import { prepareContractorFields189hu1o90mnmf as prepareContractorFields } from './ContractorFields.mjs';
import { prepareContractorDocumentFields3tjqhx4jsxti4 as prepareContractorDocumentFields } from './ContractorDocumentFields.mjs';
import { prepareContractorNoteFieldsaea4hwoz1qax as prepareContractorNoteFields } from './ContractorNoteFields.mjs';
import { prepareItemChangeFields3jbtyyrhv73f3 as prepareItemChangeFields } from './ItemChangeFields.mjs';
import { prepareLicenseFieldsqamx9w9g5tiv as prepareLicenseFields } from './LicenseFields.mjs';
import { prepareSpecificationFields1zah77c13djk7 as prepareSpecificationFields } from './SpecificationFields.mjs';
import { prepareLineItemFieldspd7i192xwmqb as prepareLineItemFields } from './LineItemFields.mjs';
import { preparePayApplicationFields2nbs32s76xjhm as preparePayApplicationFields } from './PayApplicationFields.mjs';
import { preparePayAppItemFieldsz9ai2rbsqcik as preparePayAppItemFields } from './PayAppItemFields.mjs';
import { preparePayoutFields2wdvzk40fr45j as preparePayoutFields } from './PayoutFields.mjs';
import { preparePendingItemChangeFields2n09ft4jr8tyv as preparePendingItemChangeFields } from './PendingItemChangeFields.mjs';
import { preparePendingLineItemFields1ph1cetuo0itc as preparePendingLineItemFields } from './PendingLineItemFields.mjs';
import { prepareProjectFields3fakc8cuzeqc3 as prepareProjectFields } from './ProjectFields.mjs';
import { prepareLockInfoFields1slwxs30de1hf as prepareLockInfoFields } from './LockInfoFields.mjs';
import { prepareFundsRequestFields1v1yc7vwqutxm as prepareFundsRequestFields } from './FundsRequestFields.mjs';
import { prepareProjectLedgerItemFieldswo0bcmjprn3g as prepareProjectLedgerItemFields } from './ProjectLedgerItemFields.mjs';
import { prepareExternalDepositFields1kevjrv94n54x as prepareExternalDepositFields } from './ExternalDepositFields.mjs';
import { preparePunchListItemFieldsn208pxa5rl4c as preparePunchListItemFields } from './PunchListItemFields.mjs';
import { prepareScopeViewFields2eqwutoyttf1v as prepareScopeViewFields } from './ScopeViewFields.mjs';
import { prepareTradeFields1xnthf8tnsyqb as prepareTradeFields } from './TradeFields.mjs';
import { prepareApprovedStateFields2xaeuenjwqlt5 as prepareApprovedStateFields } from './ApprovedStateFields.mjs';
import { prepareEntityTypeFields2zn5hxn126pi0 as prepareEntityTypeFields } from './EntityTypeFields.mjs';
import { prepareUserFields1dplnl5p8nrb0 as prepareUserFields } from './UserFields.mjs';
import { prepareLineItemCompletionMessageFields1z4f3fy1nqpg as prepareLineItemCompletionMessageFields } from './LineItemCompletionMessageFields.mjs';
import { prepareCompletionMessageCommentFields3ed6d955pfr4z as prepareCompletionMessageCommentFields } from './CompletionMessageCommentFields.mjs';
import { prepareProjectTimerFields3bq34fr6eveey as prepareProjectTimerFields } from './ProjectTimerFields.mjs';
import { prepareDisputeFields1rkdlu6hnhzr7 as prepareDisputeFields } from './DisputeFields.mjs';
import { prepareIncidentFields12s4axzaywy4c as prepareIncidentFields } from './IncidentFields.mjs';
import { prepareIncidentMessageFields3j9u9bef4r284 as prepareIncidentMessageFields } from './IncidentMessageFields.mjs';
import { prepareIncidentMessageCommentFields1oieun7s2tnlc as prepareIncidentMessageCommentFields } from './IncidentMessageCommentFields.mjs';
import { prepareProjectMessageFields29a8dqjn3j22h as prepareProjectMessageFields } from './ProjectMessageFields.mjs';
import { prepareProjectSettlementDocumentationFields1rkui3um63log as prepareProjectSettlementDocumentationFields } from './ProjectSettlementDocumentationFields.mjs';
import { prepareUnlockProjectRequestFields39v0wbswlqc4j as prepareUnlockProjectRequestFields } from './UnlockProjectRequestFields.mjs';
import { prepareMailCheckPhysicallyFields1bmujxna89sjm as prepareMailCheckPhysicallyFields } from './MailCheckPhysicallyFields.mjs';
import { prepareRequestFields1o0zztds0oty as prepareRequestFields } from './RequestFields.mjs';
import { prepareIncidentResponseTypeSerializableFields1f70ohdtw8frd as prepareIncidentResponseTypeSerializableFields } from './incidentResponse/IncidentResponseTypeSerializableFields.mjs';
import { prepareCompletionResponseSerializableFieldszx964npiada as prepareCompletionResponseSerializableFields } from './completionResponse/CompletionResponseSerializableFields.mjs';
import { prepareAccessInfoFields1zroiczk1n32t as prepareAccessInfoFields } from './AccessInfoFields.mjs';
import { prepareAccessAndFeedbackFields1d9qkivapa7xk as prepareAccessAndFeedbackFields } from './AccessAndFeedbackFields.mjs';
import { prepareAddressFields1ltrjfg0qd9gx as prepareAddressFields } from './AddressFields.mjs';
import { prepareProjectAttachmentFields1yfzud6ogszfz as prepareProjectAttachmentFields } from './ProjectAttachmentFields.mjs';
import { prepareClientFeedbackFieldsm5trhzd2yxmc as prepareClientFeedbackFields } from './ClientFeedbackFields.mjs';
import { prepareCompletionRequestFields3v93uvsqk2qc1 as prepareCompletionRequestFields } from './CompletionRequestFields.mjs';
import { prepareLineItemDisputeFields1qk8n0mnxy06m as prepareLineItemDisputeFields } from './LineItemDisputeFields.mjs';
import { prepareFiledForArbitrationFields1j86gdxivz92e as prepareFiledForArbitrationFields } from './FiledForArbitrationFields.mjs';
import { prepareUserMembershipFields2je7h0x74xy12 as prepareUserMembershipFields } from './UserMembershipFields.mjs';
import { prepareChangeRequestInfoFields32aye1bigimpf as prepareChangeRequestInfoFields } from './ChangeRequestInfoFields.mjs';
import { prepareIssueFieldsfnt334grlgm6 as prepareIssueFields } from './IssueFields.mjs';
import { prepareCreditFields263pps5obgt9k as prepareCreditFields } from './CreditFields.mjs';
import { prepareEmailDataFields2nhge48v440ey as prepareEmailDataFields } from './EmailDataFields.mjs';
import { prepareCrowPayAlertFields2zbi6walp1njt as prepareCrowPayAlertFields } from './CrowPayAlertFields.mjs';
import { prepareSetupFailedFields15fzbzwt2ifs4 as prepareSetupFailedFields } from './SetupFailedFields.mjs';
import { prepareSpecViewFields24nshxp1fdn9z as prepareSpecViewFields } from './SpecViewFields.mjs';
import { prepareEventTypeFields24sy6awcbqv5s as prepareEventTypeFields } from './notifications/EventTypeFields.mjs';
import { prepareEventFieldsuypk88vril5i as prepareEventFields } from './notifications/EventFields.mjs';
import { prepareUserEventTypeFields2fkfy6hlfz70o as prepareUserEventTypeFields } from './notifications/UserEventTypeFields.mjs';
import { prepareEventSubscriptionFields3trb33um5wei2 as prepareEventSubscriptionFields } from './notifications/EventSubscriptionFields.mjs';
import { prepareBasicFieldsni689atozb9s as prepareBasicFields } from './notifications/BasicFields.mjs';
import { prepareNotificationFields1m7m2qdauumrw as prepareNotificationFields } from './notifications/NotificationFields.mjs';
import { prepareNotificationFrequencyFields39u6364rcnx1g as prepareNotificationFrequencyFields } from './notifications/NotificationFrequencyFields.mjs';
import { prepareTimeInZoneFields3he4wzvtrtx34 as prepareTimeInZoneFields } from './notifications/TimeInZoneFields.mjs';
import { preparePaymentMethodFields3nobdwycnm1at as preparePaymentMethodFields } from './PaymentMethodFields.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance1an2l1q3snzzy as Companion_getInstance_2 } from './readReceipts.mjs';
import {
  Companion_getInstancefq4vwlyjorqo as Companion_getInstance_3,
  Companion_getInstance2uur5hs3fk4e5 as Companion_getInstance_4,
  Companion_getInstance1t0noik4ocb5x as Companion_getInstance_5,
  Companion_getInstance307sotgyzbnou as Companion_getInstance_6,
  Companion_getInstance124t3fbljdbyi as Companion_getInstance_7,
  Companion_getInstance14au1t142dbyp as Companion_getInstance_8,
  Companion_instance3eje2t5q7hpt as Companion_instance,
  Companion_getInstance1b21bhtdgqkve as Companion_getInstance_9,
  Companion_getInstance3r9dph6rgwho0 as Companion_getInstance_10,
  Companion_getInstance12ven2xbljkm0 as Companion_getInstance_11,
  Companion_getInstance20myouriyv3u as Companion_getInstance_12,
  Companion_getInstancee6k6ib2dkotb as Companion_getInstance_13,
  Companion_getInstance11rxtahezlto7 as Companion_getInstance_14,
  Companion_getInstancex3rnna8pnr6f as Companion_getInstance_15,
  Companion_getInstance1h9pz6hxur4uj as Companion_getInstance_16,
  Companion_getInstance28gwov6pby7lz as Companion_getInstance_17,
  Companion_getInstance39he8wfhznx8z as Companion_getInstance_18,
  Companion_getInstance30idiynnpnbn2 as Companion_getInstance_19,
  Companion_getInstance14mfei2uzw3x6 as Companion_getInstance_20,
  Companion_getInstance1cdih9ztewhpv as Companion_getInstance_21,
  Companion_instance1x10wxdaspp9d as Companion_instance_0,
  Companion_getInstancexfdqyjk2ykmw as Companion_getInstance_22,
  Companion_getInstance2m617r7l2yg9j as Companion_getInstance_23,
  Companion_getInstance3g7lwy1meor8x as Companion_getInstance_24,
  Companion_getInstance2eaghgpohvp5v as Companion_getInstance_25,
  Companion_getInstanceha7z78i7nvow as Companion_getInstance_26,
  Companion_instance2x6o1nijtl11 as Companion_instance_1,
  Companion_getInstance3bisd6gjnm0oz as Companion_getInstance_27,
  Companion_instancevwupp4fz0ehs as Companion_instance_2,
  Companion_getInstance21u335vgn0mpe as Companion_getInstance_28,
  Companion_getInstance1moufct3sbct9 as Companion_getInstance_29,
  Companion_getInstance1z8if8hzu5ng5 as Companion_getInstance_30,
  Companion_getInstance3lubwpz5lc00p as Companion_getInstance_31,
  Companion_getInstance2yrqgx0jqnq3c as Companion_getInstance_32,
  Companion_getInstanceh1cmko92158x as Companion_getInstance_33,
  Companion_getInstance12sgbyys5mml7 as Companion_getInstance_34,
  Companion_getInstancezuwazqbeik8p as Companion_getInstance_35,
  Companion_getInstance1up45os1rj3ws as Companion_getInstance_36,
  Companion_getInstance1cc7a4v9g7e6l as Companion_getInstance_37,
  Companion_getInstance20w8n5s732u9i as Companion_getInstance_38,
  Companion_getInstancese711cjybj43 as Companion_getInstance_39,
  Companion_getInstance1852qti57cam2 as Companion_getInstance_40,
  Companion_getInstance3ar1by5trsbn7 as Companion_getInstance_41,
  Companion_getInstance241hfcdeiz4z5 as Companion_getInstance_42,
  Companion_getInstance19tkudxb52ql0 as Companion_getInstance_43,
  Companion_instance3cy7oygvo3vp5 as Companion_instance_3,
  Companion_getInstance1mn08iy8k7084 as Companion_getInstance_44,
} from './databaseModels.mjs';
import {
  Companion_getInstance47wfz1otatcx as Companion_getInstance_45,
  Companion_getInstance6w6jp4uopqll as Companion_getInstance_46,
} from './incidentResponse/serialization.mjs';
import { Companion_getInstance240fx64zw6f6d as Companion_getInstance_47 } from './incidentResponse/IncidentResponseType.mjs';
import {
  Companion_getInstance139dzwc3zihpx as Companion_getInstance_48,
  Companion_getInstance242i5aydvbw67 as Companion_getInstance_49,
} from './completionResponse/serialization.mjs';
import {
  Companion_getInstance2lamxtrpb4qa0 as Companion_getInstance_50,
  Companion_getInstance1qsusdia96csy as Companion_getInstance_51,
} from './completionResponse/CompletionResponse.mjs';
import {
  Companion_getInstance3qf32mccbb2zd as Companion_getInstance_52,
  Companion_instancev69jsgezlim0 as Companion_instance_4,
  Companion_getInstance2aea3v0bp26v5 as Companion_getInstance_53,
  Companion_getInstance2siu14nwnk7au as Companion_getInstance_54,
  Companion_instancegh74vger0zhj as Companion_instance_5,
  Companion_getInstance1ezkh7nuucouo as Companion_getInstance_55,
  Companion_getInstance2irbwqyuggdu2 as Companion_getInstance_56,
  Companion_instance1py5plpe5wxpw as Companion_instance_6,
  Companion_getInstance1os6jge06wszv as Companion_getInstance_57,
} from './reports/reports.mjs';
import {
  Companion_getInstance3bhagfzu8ngcb as Companion_getInstance_58,
  Companion_getInstance3j1gp0u14zpbx as Companion_getInstance_59,
  Companion_getInstance2no072znj4dgc as Companion_getInstance_60,
  Companion_getInstance68aky2bnsasg as Companion_getInstance_61,
  Companion_getInstance3oueq6ubvzdqu as Companion_getInstance_62,
  Companion_getInstance3soflne3we53q as Companion_getInstance_63,
  Companion_getInstance24kv293bymss5 as Companion_getInstance_64,
  Companion_getInstance1toq7c46z6qs1 as Companion_getInstance_65,
  Companion_getInstance9bswgra0rac8 as Companion_getInstance_66,
  Companion_getInstance8z0585d1ojl8 as Companion_getInstance_67,
  Companion_getInstancex9879gcn3f42 as Companion_getInstance_68,
  Companion_getInstance30zv25jlmpi4e as Companion_getInstance_69,
  Companion_getInstance3jlmhbtm50921 as Companion_getInstance_70,
  Companion_getInstance1i8v5a4alj7fe as Companion_getInstance_71,
} from './enums.mjs';
import {
  Companion_getInstance1twm7uvvfawb7 as Companion_getInstance_72,
  Companion_getInstance1tv6bohtg8v20 as Companion_getInstance_73,
  Companion_instancem42ud6s3tl46 as Companion_instance_7,
  Companion_getInstance24elb6i7hza1u as Companion_getInstance_74,
  Companion_getInstance3nuke4pai11e0 as Companion_getInstance_75,
  Companion_getInstance3np43kcxu1zz as Companion_getInstance_76,
  Companion_getInstance2rck9zq8d70cs as Companion_getInstance_77,
  Companion_getInstancew45eaidw2uv as Companion_getInstance_78,
  Companion_getInstance6uhn60p4e96h as Companion_getInstance_79,
  Companion_getInstance1zugja4gs8z3u as Companion_getInstance_80,
  Companion_getInstance30yubwp5g6mt7 as Companion_getInstance_81,
  Companion_instance3pg67jx8dhjow as Companion_instance_8,
  Companion_getInstanceutfzi4qvx3rh as Companion_getInstance_82,
  Companion_getInstance1rq8nd060y61d as Companion_getInstance_83,
  Companion_getInstance3snrp0mvkuou8 as Companion_getInstance_84,
  Companion_getInstanceus6z4605rk5c as Companion_getInstance_85,
  Companion_getInstance95jshvyfe4f5 as Companion_getInstance_86,
  Companion_instance3d4t1ayx8gev1 as Companion_instance_9,
  Companion_getInstance1am9aucrot1gq as Companion_getInstance_87,
  Companion_getInstance2aw7vbmm2h3t7 as Companion_getInstance_88,
  Companion_getInstance3mwnn7es55j4h as Companion_getInstance_89,
  Companion_getInstance2m9opt1pp6vj6 as Companion_getInstance_90,
  Companion_instance1jgtwyaz4kdue as Companion_instance_10,
  Companion_instance3tofa634sddcx as Companion_instance_11,
  Companion_instance2323gbvzg2l6b as Companion_instance_12,
  Companion_getInstance29f2rub45de3p as Companion_getInstance_91,
  Companion_instance7oj7gdhawh9q as Companion_instance_13,
  Companion_getInstanceop74a2t78ktp as Companion_getInstance_92,
  Companion_getInstance18b2ua6mxmxtg as Companion_getInstance_93,
  Companion_instance1jr11iungn4qh as Companion_instance_14,
  Companion_getInstance3newi3yfn54ei as Companion_getInstance_94,
  Companion_getInstanceam0xkkf9ek as Companion_getInstance_95,
  Companion_getInstance1cbscub8vwbod as Companion_getInstance_96,
  Companion_instancet9lyvx4dyg0w as Companion_instance_15,
  Companion_getInstance3c3yiwvq39b64 as Companion_getInstance_97,
  Companion_getInstance3dtgneissrfcv as Companion_getInstance_98,
  Companion_getInstance3w82ho14xgrz as Companion_getInstance_99,
  Companion_getInstance10mviaqk2elyr as Companion_getInstance_100,
  Companion_getInstancem5ekhykter02 as Companion_getInstance_101,
  Companion_instance204uo7fmjm4u6 as Companion_instance_16,
  Companion_getInstance2vq5qbtte0dqu as Companion_getInstance_102,
  Companion_getInstance1ymmu806vd2tw as Companion_getInstance_103,
  Companion_instance1n8yqmuuwqhm2 as Companion_instance_17,
  Companion_instance357q0zxkn8vu9 as Companion_instance_18,
} from './supportModels.mjs';
import { Companion_getInstance1xwqxy6002qfp as Companion_getInstance_104 } from './URLs.mjs';
import {
  Companion_getInstance3e01hyoglo9cg as Companion_getInstance_105,
  Companion_instance23twvevqmkwz3 as Companion_instance_19,
  Companion_getInstance1pm21rm4g8yt9 as Companion_getInstance_106,
  Companion_getInstance2ux8slnf673tk as Companion_getInstance_107,
  Companion_getInstance3fc04w44tnnxx as Companion_getInstance_108,
  Companion_getInstance1ekgwm3otbuw3 as Companion_getInstance_109,
  ColonFormat_getInstance14qno77g2td0r as ColonFormat_getInstance,
  Companion_getInstance544xgdwkg8nq as Companion_getInstance_110,
  Companion_getInstance3419nzeuc2vrz as Companion_getInstance_111,
  MMDDYYYY_getInstance2zfg7h035jsgk as MMDDYYYY_getInstance,
  MMDDYYYY_HMM_getInstancec47kvy9xs1yn as MMDDYYYY_HMM_getInstance,
  Companion_getInstance9qjsly3b74n0 as Companion_getInstance_112,
} from './CSVFormatting.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  Companion_getInstanceidce664s8rcz as Companion_getInstance_113,
  Companion_instancevt78qdise4qh as Companion_instance_20,
  Companion_getInstance23zmguv2nlvyd as Companion_getInstance_114,
  Companion_getInstance2a6946bmnnmyk as Companion_getInstance_115,
  Companion_getInstance1pftqwqxp7rhm as Companion_getInstance_116,
  Companion_instance2aoezwcxpm6pa as Companion_instance_21,
  Companion_getInstance2tq82jyrde4r as Companion_getInstance_117,
  Companion_getInstancengmzgdfq20id as Companion_getInstance_118,
  Companion_instance20vpendjsus8n as Companion_instance_22,
} from './notifications/shared.mjs';
import {
  Companion_getInstance2apjme156k7ik as Companion_getInstance_119,
  Companion_getInstance2dluix7bymsgj as Companion_getInstance_120,
  Companion_getInstance32uepvayd1rp6 as Companion_getInstance_121,
  Companion_instance9tm2i64vxmrs as Companion_instance_23,
  Companion_instance1cl4ylbs1tj5h as Companion_instance_24,
  Companion_instance3r6ft9suoephw as Companion_instance_25,
  Companion_instance232bst47rpkpx as Companion_instance_26,
  Companion_getInstancelcczxht3hulj as Companion_getInstance_122,
  Companion_getInstancehvtw6329m862 as Companion_getInstance_123,
  Companion_getInstance1puvd92z6jrz1 as Companion_getInstance_124,
  Companion_getInstance2n82k3fb4nex0 as Companion_getInstance_125,
} from './paymentModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareModelsShared() {
  SharedModelsObject_getInstance();
}
function SharedModelsObject$lambda(it) {
  return new (SerializableAnnotation())('com.crowpay.MonetaryRange', mapOf([to('min', Companion_getInstance().l3h(it.b8q_1)), to('max', Companion_getInstance().l3h(it.c8q_1))]));
}
var SharedModelsObjectClass;
function SharedModelsObject() {
  if (SharedModelsObjectClass === VOID) {
    class $ {
      constructor() {
        SharedModelsObject_instance = this;
        registerShared(Companion_getInstance_1().x3i_1);
        prepareCrowPayLegalDocumentFields();
        prepareLegalDocumentAgreementFields();
        prepareChangeRequestFields();
        prepareClientFields();
        prepareOwnerFields();
        prepareContractorFields();
        prepareContractorDocumentFields();
        prepareContractorNoteFields();
        prepareItemChangeFields();
        prepareLicenseFields();
        prepareSpecificationFields();
        prepareLineItemFields();
        preparePayApplicationFields();
        preparePayAppItemFields();
        preparePayoutFields();
        preparePendingItemChangeFields();
        preparePendingLineItemFields();
        prepareProjectFields();
        prepareLockInfoFields();
        prepareFundsRequestFields();
        prepareProjectLedgerItemFields();
        prepareExternalDepositFields();
        preparePunchListItemFields();
        prepareScopeViewFields();
        prepareTradeFields();
        prepareApprovedStateFields();
        prepareEntityTypeFields();
        prepareUserFields();
        prepareLineItemCompletionMessageFields();
        prepareCompletionMessageCommentFields();
        prepareProjectTimerFields();
        prepareDisputeFields();
        prepareIncidentFields();
        prepareIncidentMessageFields();
        prepareIncidentMessageCommentFields();
        prepareProjectMessageFields();
        prepareProjectSettlementDocumentationFields();
        prepareUnlockProjectRequestFields();
        prepareMailCheckPhysicallyFields();
        prepareRequestFields();
        prepareIncidentResponseTypeSerializableFields();
        prepareCompletionResponseSerializableFields();
        prepareAccessInfoFields();
        prepareAccessAndFeedbackFields();
        prepareAddressFields();
        prepareProjectAttachmentFields();
        prepareClientFeedbackFields();
        prepareCompletionRequestFields();
        prepareLineItemDisputeFields();
        prepareFiledForArbitrationFields();
        prepareUserMembershipFields();
        prepareChangeRequestInfoFields();
        prepareIssueFields();
        prepareCreditFields();
        prepareEmailDataFields();
        prepareCrowPayAlertFields();
        prepareSetupFailedFields();
        prepareSpecViewFields();
        var tmp = Companion_getInstance_0();
        tmp.a3j('com.crowpay.MonetaryRange', SharedModelsObject$lambda);
        prepareEventTypeFields();
        prepareEventFields();
        prepareUserEventTypeFields();
        prepareEventSubscriptionFields();
        prepareBasicFields();
        prepareNotificationFields();
        prepareNotificationFrequencyFields();
        prepareTimeInZoneFields();
        preparePaymentMethodFields();
      }
    }
    initMetadataForObject($, 'SharedModelsObject');
    SharedModelsObjectClass = $;
  }
  return SharedModelsObjectClass;
}
var SharedModelsObject_instance;
function SharedModelsObject_getInstance() {
  if (SharedModelsObject_instance === VOID)
    new (SharedModelsObject())();
  return SharedModelsObject_instance;
}
function registerShared(_this__u8e3s4) {
  _this__u8e3s4.f3j(Companion_getInstance_2().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_3().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_4().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_5().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_6().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_7().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_8().k2a());
  _this__u8e3s4.f3j(Companion_instance.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_9().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_10().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_11().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_12().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_13().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_14().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_15().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_16().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_17().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_18().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_19().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_20().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_21().k2a());
  _this__u8e3s4.f3j(Companion_instance_0.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_22().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_23().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_24().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_25().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_26().k2a());
  _this__u8e3s4.f3j(Companion_instance_1.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_27().k2a());
  _this__u8e3s4.f3j(Companion_instance_2.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_28().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_29().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_30().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_31().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_32().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_33().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_34().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_35().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_36().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_37().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_38().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_39().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_40().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_41().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_42().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_43().k2a());
  _this__u8e3s4.f3j(Companion_instance_3.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_44().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_45().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_46().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_47().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_48().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_49().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_50().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_51().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_52().k2a());
  _this__u8e3s4.f3j(Companion_instance_4.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_53().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_54().k2a());
  _this__u8e3s4.f3j(Companion_instance_5.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_55().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_56().k2a());
  _this__u8e3s4.f3j(Companion_instance_6.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_57().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_58().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_59().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_60().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_61().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_62().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_63().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_64().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_65().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_66().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_67().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_68().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_69().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_70().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_71().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_72().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_73().k2a());
  _this__u8e3s4.f3j(Companion_instance_7.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_74().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_75().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_76().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_77().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_78().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_79().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_80().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_81().k2a());
  _this__u8e3s4.f3j(Companion_instance_8.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_82().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_83().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_84().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_85().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_86().k2a());
  _this__u8e3s4.f3j(Companion_instance_9.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_87().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_88().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_89().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_90().k2a());
  _this__u8e3s4.f3j(Companion_instance_10.k2a());
  _this__u8e3s4.f3j(Companion_instance_11.k2a());
  _this__u8e3s4.f3j(Companion_instance_12.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_91().k2a());
  _this__u8e3s4.f3j(Companion_instance_13.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_92().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_93().k2a());
  _this__u8e3s4.f3j(Companion_instance_14.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_94().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_95().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_96().k2a());
  _this__u8e3s4.f3j(Companion_instance_15.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_97().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_98().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_99().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_100().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_101().k2a());
  _this__u8e3s4.f3j(Companion_instance_16.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_102().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_103().k2a());
  _this__u8e3s4.f3j(Companion_instance_17.k2a());
  _this__u8e3s4.f3j(Companion_instance_18.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_104().k2a());
  var tmp = Companion_getInstance_105().l3k(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp, registerShared$lambda);
  var tmp_0 = Companion_instance_19.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_0, registerShared$lambda_0);
  var tmp_1 = Companion_getInstance_106().l3k(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_1, registerShared$lambda_1);
  var tmp_2 = Companion_getInstance_107().l3k(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_2, registerShared$lambda_2);
  _this__u8e3s4.f3j(Companion_getInstance_108().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_109().k2a());
  _this__u8e3s4.f3j(ColonFormat_getInstance().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_110().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_111().k2a());
  _this__u8e3s4.f3j(MMDDYYYY_getInstance().k2a());
  _this__u8e3s4.f3j(MMDDYYYY_HMM_getInstance().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_112().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_113().k2a());
  _this__u8e3s4.f3j(Companion_instance_20.k2a());
  var tmp_3 = Companion_getInstance_114().c8k(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_3, registerShared$lambda_3);
  var tmp_4 = Companion_getInstance_115().c8k(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_4, registerShared$lambda_4);
  var tmp_5 = Companion_getInstance_116().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_5, registerShared$lambda_5);
  _this__u8e3s4.f3j(Companion_instance_21.k2a());
  var tmp_6 = Companion_getInstance_117().g8m(NothingSerializer(), NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_6, registerShared$lambda_6);
  _this__u8e3s4.f3j(Companion_getInstance_118().k2a());
  _this__u8e3s4.f3j(Companion_instance_22.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_119().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_120().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_121().k2a());
  _this__u8e3s4.f3j(Companion_instance_23.k2a());
  _this__u8e3s4.f3j(Companion_instance_24.k2a());
  _this__u8e3s4.f3j(Companion_instance_25.k2a());
  _this__u8e3s4.f3j(Companion_instance_26.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_122().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_123().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_124().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_125().k2a());
}
function registerShared$lambda(it) {
  return Companion_getInstance_105().l3k(it[0]);
}
function registerShared$lambda_0(it) {
  return Companion_instance_19.b2j(it[0]);
}
function registerShared$lambda_1(it) {
  return Companion_getInstance_106().l3k(it[0]);
}
function registerShared$lambda_2(it) {
  return Companion_getInstance_107().l3k(it[0]);
}
function registerShared$lambda_3(it) {
  return Companion_getInstance_114().c8k(it[0]);
}
function registerShared$lambda_4(it) {
  return Companion_getInstance_115().c8k(it[0]);
}
function registerShared$lambda_5(it) {
  return Companion_getInstance_116().b2j(it[0]);
}
function registerShared$lambda_6(it) {
  return Companion_getInstance_117().g8m(it[0], it[1]);
}
//region block: exports
export {
  prepareModelsShared as prepareModelsShared1huernlq3uv7w,
};
//endregion

//# sourceMappingURL=prepareModelsShared.mjs.map
